var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('simple-table',{attrs:{"title":"Users","url":"/entity/users","columns":_vm.tableColumns,"actions":_vm.actions,"add-enabled":true,"is-entity":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }